import en from './en-US';

const resources = {
  en,
};

export default resources;
